import { Box } from "@jti/core-components/components/Box";
import type { Address } from "@jti/fe-common";
import type { IOrderAttributeOutput } from "@jti/magento";
import { AddressInfoBlock, OrderAttributesInfo } from "@jti/ui";

type OrderAddressesType = {
  address: Address;
  title: string;
  className: string;
  orderAttributesInfos?: IOrderAttributeOutput[];
};

export const OrderAddresses = ({ address, title, className, orderAttributesInfos }: OrderAddressesType) => {
  const { name: companyName } = address?.pickupInformation || {};

  return (
    <div className={className}>
      <Box title={title} variant="level-2">
        <AddressInfoBlock
          address={address}
          hideTelephone
          isEditable={false}
          companyName={companyName}
          hideName={!!companyName}
        />
        {orderAttributesInfos && <OrderAttributesInfo orderAttributesInfos={orderAttributesInfos} />}
      </Box>
    </div>
  );
};
